export default __webpack_public_path__ + "./fonts/warning.092ad831.svg";